import WrappedComponent from './wrapped-component';

export default WrappedComponent;
